import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Button } from "@material-ui/core";
import EmbaettiFilter from "pages/urvinnslur/components/filters/EmbaettiFilter";
import KjordaemiFilter from "pages/urvinnslur/components/filters/KjordaemiFilter";
import KjorstadirFilter from "pages/urvinnslur/components/filters/KjorstadirFilter";
import SveitarfelagFilter from "pages/urvinnslur/components/filters/SveitarfelagFilter";
import KosningSelect from "pages/tolfraedi/components/KosningSelect";
import DagsetningFraFilter from "pages/tolfraedi/components/filters/DagsetningFraFilter";
import DagsetningTilFilter from "pages/tolfraedi/components/filters/DagsetningTilFilter";
import TimeFilter from "pages/urvinnslur/components/TimeFilter";
import { createQueryParamsFromFilters } from "common/services/apiService";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: '32px'
  },
  titleSection: {
    textAlign: 'left',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  titleText: {
    textTransform: 'uppercase',
    borderBottom: '3px solid',
    borderBottomColor: theme.palette.primary.main,
  },
  button: {
    marginTop: '16px'
  }
}));

export default function AtkvaedalistiByEmbaetti() {
  const classes = useStyles();
  const [kosningId, setKosningId] = useState('');
  const [filters, setFilters] = useState(null);
  const [kjordaemisnumerFromFilter, setKjordaemisnumerFromFilter] = useState('');
  const [kjorstadirFromFilter, setKjorstadirFromFilter] = useState([]);
  const [sveitarfelagsnumerFromFilter, setSveitarfelagsnumerFromFilter] = useState('');

    const downloadAtkvaedalistiByEmbaettiReport = () => {

      let queryParams = createQueryParamsFromFilters(filters);

    const url = `/api/urvinnsla/atkvaedalisti/${kosningId}?${queryParams}`;

    window.open(url);
  }

  // Check for required params
  const validate = () => {
    if (filters !== null && kosningId !== '') {
      return filters.embaettisnumer !== undefined && filters.embaettisnumer !== '';
    }
  }



  const isKjordaemiSelected = () => {
    if (filters !== null) {
      return filters.kjordaemisnumer !== undefined && filters.kjordaemisnumer !== '';
    }
  }

  return (
    <div className={classes.root}>
      <Typography className={classes.titleSection} variant="h5" component="h2">
        <strong className={classes.titleText}>
          Sækja atkvæðalista eftir embætti
        </strong>
      </Typography>
      <Typography style={{ marginTop: "16px", marginBottom: "8px" }}>
        Aðgerðin skilar Excel skjali sem inniheldur öll atkvæði sem skráð voru
        hjá gefnu embætti.
      </Typography>
      <Grid container direction="row">
        <KosningSelect setKosningId={setKosningId} />
      </Grid>
      <Grid container direction="row" spacing={2} justify="flex-start">
        <Grid item>
          <EmbaettiFilter setFilters={setFilters} />
        </Grid>
        <Grid item>
          <KjordaemiFilter
            setFilters={setFilters}
            setKjordaemisnumerFromFilter={setKjordaemisnumerFromFilter}
            disabled={!validate()}
          />
        </Grid>
        <Grid item>
          <SveitarfelagFilter
            setFilters={setFilters}
            setSveitarfelagsnumerFromFilter={setSveitarfelagsnumerFromFilter}
            kjordaemisnumer={kjordaemisnumerFromFilter}
            kjorstadir={kjorstadirFromFilter}
            disabled={!isKjordaemiSelected()}
          />
        </Grid>
        <Grid item>
          <KjorstadirFilter
            setFilters={setFilters}
            kjordaemisnumer={kjordaemisnumerFromFilter}
            sveitarfelagsnumer={sveitarfelagsnumerFromFilter}
            setKjorstadirFromFilter={setKjorstadirFromFilter}
            disabled={!isKjordaemiSelected()}
          />
        </Grid>
       </Grid>
       <Grid container direction="row" spacing={2} justify="flex-start">
              <Grid item>
                  <TimeFilter
                      label={'Dagsetning/tími frá'}
                      filterName={'fra'}
                      setFilters={setFilters}
                  />
              </Grid>
              <Grid item>
                  <TimeFilter
                      label={'Dagsetning/tími til'}
                      filterName={'til'}
                      setFilters={setFilters}
                  />
              </Grid>
        
        <Grid item>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            onClick={downloadAtkvaedalistiByEmbaettiReport}
            disabled={false}
          >
            Sækja lista
          </Button>         
         </Grid>
      </Grid>
      
      <Typography
        variant="body2"
        color="textSecondary"
        style={{ marginTop: "16px" }}
      >
        <strong>Varðandi prentun</strong>
        <br />
        Til að koma öllum dálkum fyrir á einni blaðsíðu er þægilegast að velja
        eftirfarandi:
      </Typography>
      <ul style={{ marginTop: "8px" }}>
        <Typography variant="body2" color="textSecondary">
          <li>Narrow Margins</li>
          <li>Fit All Columns on One Page</li>
        </Typography>
      </ul>
    </div>
  );
}


//<Typography variant="caption" color="secondary">
//    Athugið að nauðsynlegt er að velja embætti til að sækja lista
//</Typography>